import PropTypes from 'prop-types'
import styles from './CalificacionProducto.module.css'

const MAX_ESTRELLAS = 5
const Opiniones = ({ calificacion, comentario }) => {
  const estrellas = (
    <div className={styles.opinionEstrellas}>
      {Array.from({ length: MAX_ESTRELLAS }).map((_, i) => (
        <i
          key={i}
          className={`fa ${i < calificacion ? 'fa-star' : 'fa-star-o'} ${styles.yellowStar}`}
          aria-hidden="true"
        ></i>
      ))}
    </div>
  )

  return (
    <div className={styles.opinion}>
      {estrellas}
      <div className={styles.opinionComentario}>{comentario}</div>
    </div>
  )
}

Opiniones.propTypes = {
  calificacion: PropTypes.number.isRequired,
  comentario: PropTypes.string.isRequired
}

export default Opiniones
